import config from "config";
import upiIcon from "assets/img/payment-method/UPI.png";
import usdt from "assets/img/payment-method/USDT.png";

export const allowedMethods = [
  // {
  //   gateway: "WIRE_TRANSFER",
  //   name: "Wire Transfer",
  //   image: "/img/payment-method/wire-transfer.png",
  //   allowed: ["mt5Deposit", "fiatDeposit", "cryptoDeposit"],
  //   text: "",
  //   receipt: true,
  //   isSandbox: false,
  // },
  // {
  //   gateway: "UPI",
  //   name: "UPI",
  //   image: upiIcon,
  //   allowed: ["mt5Deposit", "fiatDeposit", "cryptoDeposit"],
  //   receipt: true,
  // },
  // {
  //   gateway: "OLX_FOREX",
  //   name: "Olx Forex",
  //   image: "/img/payment-method/olxforex.jpeg",
  //   allowed: ["fiatDeposit"],
  //   receipt: false,
  // },
  // {
  //   gateway: "CRYPTO",
  //   name: "Crypto",
  //   image: "/img/payment-method/crypto.png",
  //   allowed: config.companyCryptoDeposit ? ["mt5Deposit", "fiatDeposit", "cryptoDeposit"] : [],
  //   receipt: true,
  // },
  // {
  //   gateway: "PAY_DO",
  //   name: "Pay Do",
  //   image: "/img/payment-method/pay-do.png",
  //   allowed: ["mt5Deposit", "fiatDeposit", "cryptoDeposit"],
  //   receipt: false,
  //   // isSandbox: true,
  // },
  // {
  //   gateway: "PAY_DO",
  //   name: "Pay Do",
  //   image: "/img/payment-method/pay-do.png",
  //   allowed: ["mt5Deposit", "fiatDeposit", "cryptoDeposit"],
  //   receipt: false,
  //   // isSandbox: true,
  // },
  // {
  //   gateway: "FINITIC_PAY",
  //   name: "Finitic Pay",
  //   image: usdt,
  //   allowed: ["mt5Deposit", "fiatDeposit", "cryptoDeposit"],
  //   receipt: false,
  //   text: "",
  //   isSandbox: false,
  // },
  // {
  //   gateway: "CYRAFA_PAY",
  //   name: "Cyrafa Pay",
  //   image: "img/payment-method/cyrafa-pay.webp",
  //   allowed: ["mt5Deposit", "fiatDeposit", "cryptoDeposit"],
  //   receipt: false,
  //   isSandbox: false,
  // },
  // {
  //   gateway: "DEUS_X",
  //   name: "Deus X Pay",
  //   image: "/img/payment-method/deus-x-pay-logo.jpg",
  //   allowed: ["mt5Deposit", "fiatDeposit", "cryptoDeposit"],
  //   receipt: false,
  //   isSandbox: false,
  // },
  // {
  //   gateway: "MBME_PAY",
  //   name: "Mbme Pay",
  //   image: "/img/payment-method/mbmepay.png",
  //   allowed: ["mt5Deposit", "fiatDeposit"],
  //   receipt: true,
  //   isSandbox: true,
  // },
  // {
  //   gateway: "VISA_MASTER",
  //   name: "visa and master",
  //   image: "/img/payment-method/1.png",
  //   allowed: ["mt5Deposit", "fiatDeposit", "cryptoDeposit"],
  //   receipt: false,
  //   isSandbox: false,
  // },
  // {
  //   gateway: "KNET_PAY",
  //   name: "K-Net Pay",
  //   image: "/img/payment-method/7.png",
  //   allowed: ["mt5Deposit", "fiatDeposit"],
  //   receipt: false,
  //   isSandbox: false,
  // },
  // {
  //   gateway: "SADAAD_PAY",
  //   name: "Sadaad Pay",
  //   image: "/img/payment-method/6.png",
  //   allowed: ["mt5Deposit", "fiatDeposit"],
  //   receipt: false,
  //   text: "pay",
  //   isSandbox: false,
  // },
  // {
  //   gateway: "HESABE",
  //   name: "Hesabe",
  //   image: "/img/payment-method/hesabe.png",
  //   allowed: ["mt5Deposit", "fiatDeposit"],
  //   receipt: false,
  //   isSandbox: false,
  // },
  {
    gateway: "VIRTUAL_PAY",
    name: "Virtual Pay",
    image: "/img/payment-method/virtual-pay.png",
    allowed: ["mt5Deposit", "fiatDeposit"],
    receipt: false,
    isSandbox: false,
  },
];
